console.log("👋");


// snipcart
document.addEventListener('snipcart.ready', function() {
    var cart = document.querySelector("#snipcart-cart");
    Snipcart.events.on('item.added', function(cartItem) {
      cart.classList.add('visible');
    });
    Snipcart.events.on('item.removed', function(cartItem) {
      if(Snipcart.api.cart.items.count > 0){
        cart.classList.add('visible');
      } else {
        cart.classList.remove('visible');
      }
    });
    Snipcart.events.on('snipcart.initialized', function(snipcartState) {
      if(snipcartState.cart.items.count > 0){
        cart.classList.add('visible');
      }
    });
  });


// Store # parameter and add "." before hash
if (window.location.hash) {
  var hashID = window.location.hash.substring(1);
}

var filtersElem = document.querySelector('.filters-button-group');
var products = document.querySelectorAll('.product');

if (filtersElem !== null) {
    var filters = filtersElem.querySelectorAll('a');
    if (hashID) {
        updateFilters(hashID);
    }
    filters.forEach( filter => { 
        filter.onclick = (e) => {            
            var category = filter.dataset.category;
            updateFilters(category);
        };
    });

}

function updateFilters(category){
    products.forEach( element => {
        if(element.classList.contains(category)){
            element.classList.remove('hidden');
        } else {
            element.classList.add('hidden');
        }
        if(category=="all") element.classList.remove('hidden');
    });
    var ischecked = filtersElem.querySelector('.is-checked');
    if(ischecked) ischecked.classList.remove('is-checked');
    let f = filtersElem.querySelector('[data-category="' + category +'"]');
    if(f)  f.classList.add('is-checked');
}


var sldshw = document.querySelector(".slider");
if(sldshw) {
    var flkty = new Flickity( sldshw, {
        // options
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: false,
        hash: true
    });
}


var album = document.querySelector("#album");
if(album){
    const justify_scale = screen.height * 0.2;
    let items = album.querySelectorAll('.gallery-item');
    Array.prototype.forEach.call(items, item => {        
        let image = item.querySelector('img');        
        image.onload = () => {
            let ratio = image.width / image.height;
            item.style.width = justify_scale * ratio + 'px';
            item.style.flexGrow = ratio;
        };
    });
}



let places = [];
var padding = 50;
var ww = window.innerWidth - padding * 2;
var wh = window.innerHeight - padding * 2;
const home = document.querySelector('#home');
if(home){
    let margintop = home.getBoundingClientRect().top - 2.25 * 16;
    console.log(margintop);
    wh = wh - margintop;
    const focus = home.querySelectorAll('.focus');
    imagesLoaded(home,function(){
        focus.forEach(f => {
            randPos(f);
        });
    });
}

// utility : randomly position passed element
function randPos(element){
    const innerpad = 5;
    var rect = element.getBoundingClientRect();
    var top = padding + Math.floor( Math.random() * (wh - rect.height) );
    var left = padding + Math.floor( Math.random() * (ww - rect.width) );
    
    var target_place = {"left":left - innerpad, "width" : rect.width + innerpad * 2, "top": top - innerpad, "height": rect.height + innerpad * 2};
    var is_place_available = true;
    places.forEach(place => {
      // check if target position overlaps previously used position
      if(
        (target_place.top >= place.top && target_place.top <= place.top + place.height  || target_place.top + target_place.height >= place.top && target_place.top <= place.top + place.height ) && (target_place.left >= place.left && target_place.left <= place.left + place.width || target_place.left + target_place.width >= place.left && target_place.left <= place.left + place.width) ){
        // occupied wall street !
        is_place_available = false;      
      }
    });
  
    // place is available, ok
    if(is_place_available){
      places.push(target_place);
      element.style.top = top + "px";
      element.style.left = left + 'px';
    } else {
      // place is not available, try another
      randPos(element);
    }
  }